/**
 * App-level Redux hooks. Use these instead of useDispatch/useSelector directly
 * so we can add typing or middleware later without touching components.
 */
import { useDispatch, useSelector } from "react-redux";

export const useAppDispatch = () => useDispatch();
export const useAppSelector = useSelector;
